export interface ClientRoleOption {
  id: string;
  name: string;
  description?: string;
}

export const ROLE_SELECTION_PAGE_SIZE = 10;

export function normalizeClientRoles(roles: any[] = []): ClientRoleOption[] {
  return roles.map((role) => ({
    ...role,
    id: String(role.id),
    name: String(role.name ?? ""),
    description: String(role.description ?? ""),
  }));
}

export function roleSelectionPage(
  roles: ClientRoleOption[],
  params: { page?: number; search_text?: string },
) {
  const query = String(params.search_text ?? "").trim().toLocaleLowerCase();
  const filtered = query
    ? roles.filter((role) =>
        `${role.name} ${role.description ?? ""}`
          .toLocaleLowerCase()
          .includes(query),
      )
    : roles;
  const page = Math.max(1, Number(params.page) || 1);
  const start = (page - 1) * ROLE_SELECTION_PAGE_SIZE;

  return {
    data: filtered.slice(start, start + ROLE_SELECTION_PAGE_SIZE),
    total: filtered.length,
  };
}
